@if (isLoading()) {
<sura-mobility-loader />
} @else {
<div class="Padre">
  <banner-app position="fixed-top" [Fixtop]="''" [retroSelected]="showBackButton()" [infoDueno]="true"
    [showPromo]="true"></banner-app>

  <main class="summary-page-container">
    <!-- <div class="header-spacer"></div> -->

    <div class="container-fluid p-0">
      <div class="summary-page__principal-row">
        <div class="col-12 col-md-6">
          <div class="details-section">

            <div class="d-block d-md-none text-center">
              <h1 class="main-title m-2 m-md-1">Revisa y paga tu seguro</h1>
              <p class="color-subtitle">Confirma que todo esté correcto y elige cómo quieres pagar.</p>
            </div>

            <app-inspection-alert class="col-md-8 mx-auto mt-3"></app-inspection-alert>

            <app-summary-plan-card [planTitle]="pagoPlan()?.name || ''" [vehicleBrand]="vehicle()?.brand || ''"
              [vehicleLine]="vehicle()?.plate || ''" [owner]="ownerInfo() || null" [city]="cuidaCirculacion()"
              [coverageLabels]="etiquetasCoberturas()" [optionalCoverageLabels]="etiquetasOpcionales()"
              [isCustomPlan]="pagoPlan()?.name === 'Plan Arma tu Plan'"
              [paymentType]="tipoPago() === 'Monthly' ? 'Mensual' : 'Anual'" [totalAmount]="valorTotalSeguro()"
              [monthlyAmount]="valorMes()" class="col-md-10 mx-auto mt-4 mt-md-5"></app-summary-plan-card>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="payment-section" [ngClass]="{ 'month-payment': tipoPago() === 'Monthly' }">
            <div class="payment-content">

              <div class="d-none d-md-block text-start">
                <h1 class="main-title m-2 m-md-1">Revisa y paga tu seguro</h1>
                <p>Confirma que todo esté correcto y elige cómo quieres pagar.</p>
              </div>
              <!-- <app-payment-summary [paymentType]="tipoPago() === 'Monthly' ? 'Mensual' : 'Anual'"
                [totalAmount]="valorAPagar()" [showDiscount]="tipoPago() === 'Annually'"></app-payment-summary> -->

              <app-policy-start-date class="d-block mt-3" [startDate]="fecha()"></app-policy-start-date>

              @if (tipoPago() !== 'Annually') {
              <div class="payment-options-container mt-4">
                <app-subscription-card class="d-block" [showSubscription]="tipoPago() === 'Monthly'"
                  [isSelected]="selectedPaymentMethod() === 'subscription'" [showPromo]="showPromo()"
                  [promoPoints]="promoPoints()" [pointsPerAmount]="pointsPerAmount()" [disabled]="isPaying()"
                  (payWithCard)="selectedPaymentMethod.set('subscription')">
                </app-subscription-card>

                @if (!isPseDisabled()) {
                <app-manual-payment-card class="d-block mt-3" [isSelected]="selectedPaymentMethod() === 'payment'"
                  [disabled]="isPaying()" (payWithPSE)="selectedPaymentMethod.set('payment')">
                </app-manual-payment-card>
                }

                <button class="summary-page__pay-button d-none d-md-block mt-4" type="button"
                  (click)="selectedPaymentMethod() ? handlePayment(selectedPaymentMethod()!) : null"
                  [disabled]="isPaying() || !selectedPaymentMethod()">
                  @if (isPaying()) {
                  <span>Procesando...</span>
                  } @else {
                  <span>Pagar</span>
                  }
                </button>
              </div>
              } @else {
              <div class="w-100 d-flex justify-content-center mt-4 flex-column align-items-center">
                <!-- <div class="summary-page__annual-tag">Ahorro del 20% incluido</div> -->
                <button class="summary-page__pay-button d-none d-md-block mt-3" type="button"
                  (click)="handlePayment('payment')" [disabled]="isPaying()">
                  @if (isPaying()) {
                  <span>Procesando...</span>
                  } @else {
                  <span>Pagar</span>
                  }
                </button>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="mobile-payment-bar d-block d-md-none">
    <div class="mobile-payment-bar__row">
      <div class="mobile-payment-bar__text">
        <span class="mobile-payment-bar__title">Hoy pagas</span>
        @if (tipoPago() === 'Monthly') {
        <span class="mobile-payment-bar__subtitle">Corresponde a tu primer mes</span>
        }
        <span class="mobile-payment-bar__tax">IVA incluido</span>
      </div>
      <div class="mobile-payment-bar__price">
        ${{ valorAPagar() | number:'1.0-0' }}
      </div>
    </div>

    <button class="mobile-payment-bar__button" type="button"
      (click)="tipoPago() !== 'Annually' ? (selectedPaymentMethod() ? handlePayment(selectedPaymentMethod()!) : null) : handlePayment('payment')"
      [disabled]="isPaying() || (tipoPago() !== 'Annually' && !selectedPaymentMethod())">
      @if (isPaying()) {
      <span>Procesando...</span>
      } @else {
      <span>Pagar</span>
      }
    </button>
  </div>
  <app-footer-app class="footer-fixed" />
</div>
}